// Tarix formatı (KT-95): ekranda gg.aa.iiii, API-də ISO YYYY-MM-DD.

/** 2026-11-01 → 01.11.2026; boş və ya səhv → ''. */
export function isoToDmy(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : '';
}

/** 01.11.2026 (və ya 1.11.2026) → 2026-11-01; mövcud olmayan gün → null. */
export function parseDmy(text: string): string | null {
  const m = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(text.trim());
  if (!m) return null;
  const iso = `${m[3]}-${m[2].padStart(2, '0')}-${m[1].padStart(2, '0')}`;
  const d = new Date(`${iso}T00:00:00Z`);
  return !Number.isNaN(d.getTime()) && d.toISOString().slice(0, 10) === iso ? iso : null;
}

/** İstifadəçinin yazdığı və ya yapışdırdığı tarix: gg.aa.iiii, gg/aa/iiii, gg-aa-iiii və ya ISO → ISO; olmazsa null. */
export function parseDateInput(text: string): string | null {
  const t = text.trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(t)) return parseDmy(isoToDmy(t));
  return parseDmy(t.replace(/[/-]/g, '.'));
}
